import axios from "axios";
import { configUrl } from "config.js";

const getAllEnquiries = async (Page, PageSize, Status, Name, Mobile, Email) => {
    let status = Status ?? null;
    let name = Name ?? null;
    let mobile = Mobile ?? null;
    let email = Email ?? null;

    let pageSize = PageSize ?? 10;
    let page = Page ?? 1;

    let Response = await axios.get(
        `${configUrl.AssessmentServer}/api/Enquiry/GetAllEnquiriesList`, {
        params: {
            pageNumber: page,
            pageSize: pageSize,
            status: status,
            name: name,
            mobile: mobile,
            email: email,
        }
    }
    );

    let testData = Response?.data;
    return testData;
};
export default {
    getAllEnquiries: getAllEnquiries,
};
